(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('InvoiceDTO', InvoiceDTO);

    InvoiceDTO.$inject = ['$resource', 'DateUtils'];

    function InvoiceDTO ($resource, DateUtils) {
        var resourceUrl =  'api/invoiceDTO/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.invoiceCreatedOn = DateUtils.convertDateTimeFromServer(data.invoiceCreatedOn);
                        data.invoiceModifiedOn = DateUtils.convertDateTimeFromServer(data.invoiceModifiedOn);
                        data.invoiceDate = DateUtils.convertLocalDateFromServer(data.invoiceDate);
                        data.invoiceDueDate = DateUtils.convertLocalDateFromServer(data.invoiceDueDate);
                        data.invoiceEstPayment = DateUtils.convertLocalDateFromServer(data.invoiceEstPayment);
                    }
                    return data;
                }
            }
        });
    }
})();
